import { YStack, XStack, Text, View } from 'tamagui'
import { useTranslation } from 'react-i18next'
import HerosparkCircleLogoSvg from '@assets/hero/herospark-circle-logo.svg'
import FooterGraphicSvg from '@assets/product/footer_graphic_detail.svg'
import { IProductPage } from '@dtos/ProductPage'
import { CONTAINER_WIDTH } from './constants'
import { ctaKind } from './helpers'
import { usePricing } from './hooks'
import { BuyButton } from './BuyButton'
import { SecurityNote } from './SecurityNote'
import { AnchorPrice, CurrentPrice, InstallmentLine } from './PriceParts'

export function FooterCopyright() {
  const { t } = useTranslation('ProductPage')

  return (
    <XStack alignItems="center" gap={8} marginTop={24}>
      <HerosparkCircleLogoSvg height={22} width={22} />
      <Text color="$text-secondary" fontSize={14} fontFamily="$mulishRegular">
        {t('copyright')}
      </Text>
    </XStack>
  )
}

function FooterPrice({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const { price, period, anchorPrice, installment, installmentKey } =
    usePricing(product)

  return (
    <XStack
      alignItems="baseline"
      gap={8}
      flexWrap="wrap"
      justifyContent="center"
    >
      <Text color="$text-primary" fontSize={16} fontFamily="$mulishRegular">
        {t('price.prefix')}
      </Text>
      {/* Coluna alinha a linha de parcelas com o início da âncora,
          como o .productPage_price do hero_theme. */}
      <YStack gap={4} alignItems="flex-start">
        <XStack alignItems="baseline" gap={8} flexWrap="wrap">
          {anchorPrice && <AnchorPrice value={anchorPrice} fontSize={16} />}
          <CurrentPrice
            price={price}
            period={period}
            color="$accent"
            fontSize={32}
            periodFontSize={16}
          />
        </XStack>
        {installment && (
          <InstallmentLine
            installment={installment}
            installmentKey={installmentKey}
            color="$cta"
            fontSize={16}
          />
        )}
      </YStack>
    </XStack>
  )
}

// Faixa final (productPage_footer): título, preço com cores invertidas
// (preço na cor de destaque, parcelas em cherry), CTA e segurança, centralizados.
export function FooterSection({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const { option, isFree } = usePricing(product)

  return (
    <View width="100%" backgroundColor="$bg-surface" marginTop={64}>
      <YStack
        width="100%"
        maxWidth={CONTAINER_WIDTH}
        alignSelf="center"
        alignItems="center"
        paddingTop={0}
        paddingBottom={48}
        paddingHorizontal={16}
        gap={24}
      >
        <FooterGraphicSvg width={115} height={61} />
        <Text
          color="$text-primary"
          fontSize={32}
          fontFamily="$mulishBold"
          fontWeight="700"
          textAlign="center"
          maxWidth={800}
        >
          {product.title}
        </Text>

        {option && !isFree && <FooterPrice product={product} />}

        <YStack alignItems="center" gap={16}>
          <BuyButton
            label={t(`cta.${ctaKind(option, product.course?.kind ?? null)}`)}
            url={option?.checkoutUrl ?? null}
            location="footer"
            product={product}
          />
          {option?.checkoutUrl && !isFree ? <SecurityNote /> : null}
        </YStack>

        <FooterCopyright />
      </YStack>
    </View>
  )
}
